
import { Toaster as HotToaster, ToastBar } from 'react-hot-toast';

export const Toaster = () => {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 5000,
      }}
    >
      {(t) => (
        <ToastBar 
          toast={t}
          style={{ padding: 0, background: 'transparent', boxShadow: 'none' }}
        >
          {({ icon, message }) => (
              <div
                className="pointer-events-auto flex max-w-sm w-[350px] items-center gap-3 sm:gap-4 p-4 sm:p-5 rounded-xl bg-[#333] border border-white/10 shadow-lg shadow-black/20"
                role="alert"
              >
                {icon}
                <div className="min-w-0 flex-1 flex">
                  <div className="text-sm sm:text-[15px] font-semibold text-white leading-snug break-words m-0">
                    {message}
                  </div>
                </div>
              </div>
          )}
        </ToastBar>
      )}
    </HotToaster>
  );
};
